export default __webpack_public_path__ + "static/Grand_Canal_Venice_Italy-7fda1d358cbde1f469f0f7ca9cddb02d.jpg";